var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.showAutorizadores,
        callback: function($$v) {
          _vm.showAutorizadores = $$v
        },
        expression: "showAutorizadores"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.cerrarModal()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
          _c("v-tabs", [_c("v-tab", [_vm._v("Seleccionar Autorizadores")])], 1),
          _c("v-divider"),
          _c(
            "div",
            {},
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Buscar", outlined: "" },
                        on: {
                          keyup: function($event) {
                            return _vm.gridApi.setQuickFilter(_vm.filtro)
                          }
                        },
                        model: {
                          value: _vm.filtro,
                          callback: function($$v) {
                            _vm.filtro = $$v
                          },
                          expression: "filtro"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                { staticClass: "gridcard rounded-card modalAutorizadores" },
                [
                  _c("MantenedorGridSinCodigo", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: {
                      funcionalidadId: _vm.funcionalidad,
                      gridOptions: _vm.gridOptions,
                      mostrarAcciones: false
                    }
                  })
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _vm.edicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar white--text",
                              on: {
                                click: function($event) {
                                  return _vm.showConfirmationEdit()
                                }
                              }
                            },
                            [_vm._v("Confirmar")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar white--text",
                              on: {
                                click: function($event) {
                                  return _vm.showConfirmation()
                                }
                              }
                            },
                            [_vm._v("Confirmar")]
                          )
                    ],
                    1
                  ),
                  _c("Confirmation", {
                    attrs: {
                      show: _vm.confirmationConfirm,
                      titulo: "Confirmar Autorizadores",
                      mensaje: "Confirmar Autorizadores a: " + _vm.usersName,
                      textoBtnSi: _vm.$t("Confirmar"),
                      textoBtnNo: _vm.$t("Cancelar")
                    },
                    on: {
                      modalConfirmationEmit: function($event) {
                        return _vm.closeConfirmation($event)
                      }
                    }
                  }),
                  _c("Confirmation", {
                    attrs: {
                      show: _vm.confirmationEdit,
                      titulo: "Editar Autorizadores",
                      mensaje:
                        "Desea Editar Los Autorizadores a: " + _vm.totalNames,
                      textoBtnSi: _vm.$t("Confirmar"),
                      textoBtnNo: _vm.$t("Cancelar")
                    },
                    on: {
                      modalConfirmationEmit: function($event) {
                        return _vm.closeConfirmationEdit($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }